import { Button, Stack } from '@mui/material';
import { type FlowHumanTaskField } from 'flow-schema';

import { Tag, isDefined } from 'common';

import {
  HUMAN_TASK_FIELDS_BY_TYPE,
  HumanTaskFieldType,
  HumanTaskFieldTypeNames,
  getDefaultHumanTaskFieldConfig,
} from './AllFields';
import { useReactFlowViewContext } from '../../../../../context/context';
import { BlockSelectField } from '../../../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../../../ConfigFields/useSelectedNodeField';
import { HumanTaskIndentContainer } from '../IndentContainer';

interface HumanTaskFieldCardProps {
  fieldIndex: number;
  fieldNamePrefix: string;
  onAdd?: () => void;
  onDelete?: () => void;
}

export function HumanTaskFieldCard(props: HumanTaskFieldCardProps) {
  const { fieldIndex, fieldNamePrefix, onAdd, onDelete } = props;
  const { value: fieldType } = useSelectedNodeField<HumanTaskFieldType | undefined>(
    `${fieldNamePrefix}.fieldType`
  );
  const { value: fieldValue, setValue: setField } =
    useSelectedNodeField<FlowHumanTaskField>(fieldNamePrefix);
  const { isEditable } = useReactFlowViewContext();
  const HumanTaskField = isDefined(fieldType) ? HUMAN_TASK_FIELDS_BY_TYPE[fieldType] : null;

  return (
    <HumanTaskIndentContainer>
      <Stack gap={1} aria-rowindex={fieldIndex + 1} aria-roledescription="Field">
        <BlockSelectField
          fieldName={`${fieldNamePrefix}.fieldType`}
          label={
            <Stack direction="row" gap={1}>
              <Tag color="primary">{fieldIndex + 1}</Tag> Field Type
            </Stack>
          }
          aria-label="Field Type"
          options={Object.values(HumanTaskFieldType).map((fieldType) => ({
            label: HumanTaskFieldTypeNames[fieldType],
            value: fieldType,
          }))}
          onChange={(event) => {
            const fieldType = event.target.value as HumanTaskFieldType;
            setField(
              getDefaultHumanTaskFieldConfig(fieldType, {
                currentValue: fieldValue,
              })
            );
          }}
        />
        {isDefined(HumanTaskField) && <HumanTaskField fieldNamePrefix={fieldNamePrefix} />}
        {isEditable && (
          <Stack gap={1} direction="row" justifyContent="flex-end">
            {isDefined(onAdd) && (
              <Button
                variant="text"
                onClick={() => {
                  onAdd();
                }}
                disabled={!isEditable}
              >
                + New field
              </Button>
            )}
            {isDefined(onDelete) && (
              <Button
                variant="text"
                color="error"
                onClick={() => {
                  onDelete();
                }}
                disabled={!isEditable}
              >
                Delete field {fieldIndex + 1}
              </Button>
            )}
          </Stack>
        )}
      </Stack>
    </HumanTaskIndentContainer>
  );
}
